import { render } from "./message-component.vue?vue&type=template&id=7d4154ba&scoped=true"
import script from "./message-component.vue?vue&type=script&lang=js"
export * from "./message-component.vue?vue&type=script&lang=js"

import "./message-component.vue?vue&type=style&index=0&id=7d4154ba&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d4154ba"]])

export default __exports__